import React from 'react';
import PlatformExperienceSurvey from './PlatformExperienceSurvey';
import './PlatformExperienceModal.css';

const PlatformExperienceModal = ({ open, source = 'modal', initialScore = 0, onClose }) => {
  if (!open) return null;

  return (
    <div className="platform-feedback-modal-overlay" role="dialog" aria-modal="true" aria-labelledby="platform-feedback-modal-title">
      <div className="platform-feedback-modal" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="platform-feedback-modal-dismiss"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        <PlatformExperienceSurvey
          key={`${source}-${initialScore}`}
          source={source}
          variant="modal"
          initialScore={initialScore}
          onClose={onClose}
        />
      </div>
    </div>
  );
};

export default PlatformExperienceModal;
